import { render, staticRenderFns } from "./NavbarVertical.vue?vue&type=template&id=6c75f444&"
import script from "./NavbarVertical.vue?vue&type=script&lang=js&"
export * from "./NavbarVertical.vue?vue&type=script&lang=js&"
import style0 from "./NavbarVertical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports